import { Currency, CurrencyAmount, ETHER, Token, TokenAmount } from '@uniswap/sdk'
import { WRAPPED_NATIVE } from '../chainConfig'

export function wrappedCurrency(currency: Currency | undefined, chainId: number | undefined): Token | undefined {
  return chainId && currency === ETHER ? WRAPPED_NATIVE : currency instanceof Token ? currency : undefined
}

export function wrappedCurrencyAmount(
  currencyAmount: CurrencyAmount | undefined,
  chainId: number | undefined
): TokenAmount | undefined {
  const token = currencyAmount && chainId ? wrappedCurrency(currencyAmount.currency, chainId) : undefined
  return token && currencyAmount ? new TokenAmount(token, currencyAmount.raw) : undefined
}

export function unwrappedToken(token: Token): Currency {
  if (token.equals(WRAPPED_NATIVE)) return ETHER
  return token
}
